/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";

const ChatBody = ({ messages, socket, lastMessageRef, roomUser, chatPreference }) => {
  const [message, setMessage] = useState('');
  const [showChatInput, setShowChatInput] = useState(false);
  const [isAllowed, setIsAllowed] = useState(false);
  const prevRoomUserLength = useRef(0);
  const { _id, name } = useSelector((state) => ({
    _id: state?.Auth?.userInfo?._id,
    name: state?.Auth?.userInfo?.name,
  }));

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (!socket) {
      return;
    }
    if (message.trim()) {
      const id = `${socket.id}${Math.random()}`;
      socket.emit('message', {
        text: [{ text: message, user: { _id, name: name }, _id: id }],
        name: name,
        teacherId: _id,
        id,
        socketID: socket.id,
        createdAt: new Date().toISOString(),
      });
    }
    setMessage('');
  };

  const handleAllow = () => {
    setIsAllowed((prev) => {
      const updatedValue = !prev;
      const id = `${socket.id}${Math.random()}`;
      socket.emit('message', {
        text: [{ text: updatedValue ? "Allowed to View Messages" : "Disallowed to View Messages", user: { _id, name }, _id: id, },],
        name: name,
        teacherId: _id,
        id: id,
        socketID: socket.id,
        isAllowed: updatedValue,
        createdAt: new Date().toISOString(),
      });
      return updatedValue;
    });
  };
useEffect(() => {
  if (!roomUser) return;
  
  const currentLength = roomUser?.users?.length;
  if (isAllowed && currentLength > prevRoomUserLength.current) {
    const id = `${socket.id}${Math.random()}`;
    socket.emit('message', {
      text: [{ text: "Allowed to View Messages", user: { _id, name }, _id: id }],
      name: name,
      teacherId: _id,
      id: id,
      socketID: socket.id,
      isAllowed: true,
    });
  }
  prevRoomUserLength.current = currentLength;

}, [roomUser]);

  const getInitials = (name = '') => {
    return name
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .map(word => word[0])
      .join('')
      .toUpperCase();
  };
  const formatTime = (dateString) => {
    const time = new Date(dateString).toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    })
    return time;
  };
  const roomUserCount = roomUser?.users?.filter(user => user.userId !== _id)?.length || 0;

  return (
    <>
      <div className={`rtmp-chat-header ${(!["1", "2"].includes(chatPreference) || (document.visibilityState === "visible" && window.location.pathname === "/ChatPage")) ? '' : 'd-none'}`}>
        <div className="live-badge">
          <svg width="10" height="10" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#EF4444" stroke="#EF4444" /></svg>
          LIVE
        </div>
        <div className="rtmp-chat-header-title">RTMP Chat</div>
        <div className="header-spacer"></div>
        <div className="toggle-group">
          <div className="toggle-item">
            <span className="toggle-item-label">Allow Students to View All Messages</span>
            <button className={` toggle-track ${isAllowed ? 'on' : 'off'}`} onClick={handleAllow}>
              <div className="toggle-thumb"></div>
            </button>
          </div>
          <div className={`toggle-item ${isAllowed ? 'public' : 'private'}`}>
            <span className={`toggle-item-label`}>
              <strong>{isAllowed ? 'PUBLIC' : 'PRIVATE'}</strong>
            </span>
            {/* <button className={`toggle-track ${showChatInput ? 'on' : 'off'}`} onClick={() => setShowChatInput((prev) => !prev)}>
              <div className="toggle-thumb"></div>
            </button> */}
          </div>
        </div>
      </div>
      <div className="message-container">
        <div className={`rtmp-sidebar ${(["1"].includes(chatPreference) || (document.visibilityState === "visible" && window.location.pathname === "/ChatPage")) ? '' : 'd-none'}`}
          style={{ width: ["1"].includes(chatPreference) ? "445px" : "280px" }}>
          <div className="sidebar-header">
            <div>
              <div className="sidebar-title">Participants</div>
              <div className="sidebar-subtitle"><span className="count">{roomUserCount}</span> active participants</div>
            </div>
          </div>

          {/* <div className="sidebar-search">
<div className="search-box">
<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" /></svg>
<input type="text" placeholder="Search students..." />
</div>
</div> */}

          <div className="student-list">
            <ul className="p-0">
              {roomUser?.users?.map((user) => (
                user?.userId !== _id && (
                  <li className="student-item" key={user.userId}>
                    <div className="avatar">{getInitials(user.name)}</div>
                    <div className="student-name">{user.name}</div>
                    <div className="status-dot active"></div>
                  </li>
                )
              ))}
            </ul>
          </div>
        </div>
        <div className={`chat-area ${(["2"].includes(chatPreference) || (document.visibilityState === "visible" && window.location.pathname === "/ChatPage")) ? '' : 'd-none'}`}>
          {/* Warning banner */}
          {!isAllowed && (
            <div className="warning-banner">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49" /><path d="M14.084 14.158a3 3 0 0 1-4.242-4.242" /><path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143" /><path d="m2 2 20 20" /></svg>
              Messages are currently hidden from students. Toggle visibility to broadcast.
            </div>
          )}

          {/* Messages */}
          <div className={`messages`} id="messagesContainer" >
            {messages.map((message) =>
              message.userId ? (
                <div className="msg-row student" key={message.id}>
                  <div className="msg-col">
                    <div className="msg-sender">{message.name}</div>
                    <div className="msg-inner">
                      <div className="avatar small">{getInitials(message.name)}</div>
                      <div className="msg-bubble">{message.text[0].text}</div>
                    </div>
                    <div className="msg-time" style={{ paddingLeft: "4px" }}>{formatTime(message.createdAt)}</div>
                  </div>
                </div>
              ) : (
                (message.text[0].text.includes("Allowed to View Messages") || message.text[0].text.includes("Disallowed to View Messages")) ? (null) : (
                  <div className="msg-row admin" key={message.id}>
                    <div className="msg-col">
                      <div className="msg-inner">
                        <div className="msg-bubble">{message.text ? message.text[0].text : ''}</div>
                      </div>
                      <div className="msg-time" style={{ paddingRight: "4px" }}>{formatTime(message.createdAt)}</div>
                      <div className="msg-visibility vis">
                        You
                      </div>
                    </div>
                  </div>
                )
              )
            )}
            <div ref={lastMessageRef} />
          </div>
          {/* COMPOSE AREA */}
          {/* {showChatInput && ( */}
          <form onSubmit={handleSendMessage}>
            <div className="compose-area">
              <div className="compose-input-area">
                <div className="compose-row">
                  <input
                    className="message"
                    placeholder="Write message..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                  <button type="submit" className={`btn btn-send ${(message?.length > 0 && message.trim() !== "") ? 'active' : 'disabled'}`}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m22 2-7 20-4-9-9-4z" /><path d="m22 2-11 11" /></svg>
                    Send
                  </button>
                </div>
              </div>
            </div>
          </form>
          {/* )} */}
        </div>
        <div className="message__status"></div>
      </div >
    </>
  );
};

export default ChatBody;
